"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartLegend = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../shared/core");
var ChartLegend_styled_1 = require("./ChartLegend.styled");
/**
 * Displays the legend at the top of the chart.
 */
var ChartLegend = function (_a) {
    var legend = _a.legend, rest = __rest(_a, ["legend"]);
    var _b = (0, core_1.useComponents)(), Ul = _b.Ul, Li = _b.Li;
    return (react_1.default.createElement(ChartLegend_styled_1.StyledChartLegend, __assign({}, rest, { as: Ul, "aria-label": "Legend" }), legend.map(function (_a) {
        var color = _a.color, label = _a.label, type = _a.type;
        return (react_1.default.createElement(ChartLegend_styled_1.StyledChartLegendItem, { key: "legend-".concat(type), as: Li },
            react_1.default.createElement(ChartLegend_styled_1.StyledChartLegendSwatch, { color: color }),
            " ",
            label));
    })));
};
exports.ChartLegend = ChartLegend;
